export enum RewardStatus {
  CLAIMED = "claimed",
  CLAIMABLE = "claimable",
  LOCKED = "locked",
}
